import FlashLib from 'flashlib_onlyplay';
import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import eEventTypes from '../enums/eEventTypes';
import EntryPoint from 'Engine/EntryPoint';
import eGameMode from '../enums/eGameMode';

export default class ControllerMiniSlot extends FlashLib.MovieClip {
  constructor(data, displayData) {
    super(data, displayData);

    this.init();
    this.addListeners();
  }

  init() {
    this.reelsContainer = this.getChildByName('reelsContainer');
    this.ControllerSlotsLight = this.getChildByName('light');
    this.ControllerSlotsLight.playAnimation(this.ControllerSlotsLight.animationTypes.CIRCLE, 400000, 1500, 0, true);
  }

  addListeners() {
    GlobalDispatcher.add(eEventTypes.EET_EXTRA_REELS_STOPPED, this.onReelsStopped, this);
  }

  onReelsStopped() {
    if (EntryPoint.GameModel.extraCoef > 1) {
      this.ControllerSlotsLight.playAnimation(this.ControllerSlotsLight.animationTypes.BLINK, 20000, 200,0, true);
    } else {
      this.ControllerSlotsLight.playAnimation(this.ControllerSlotsLight.animationTypes.CIRCLE, 400000, 1500, 0, true);
    }
  }

  start() {
    this.ControllerSlotsLight.playAnimation(this.ControllerSlotsLight.animationTypes.SNAKE, 3000, 2000, 8, false, 2);
    this.reelsContainer.start();
  }

  stop() {
    this.reelsContainer.stop();
  }
}
